<script lang="ts">
    import cn from 'classnames';

    import type { StoryFeedItem } from '@api/story/types';
    import { Spinner, SpinnerSize } from '@components/common/spinner';
    import { addUserToFavorite } from '@components/favorite/functions';
    import { storyFeedStore } from '@components/story/feed';
    import { dialogStore } from '@components/ui/dialog';
    import { LL } from '@i18n/i18n-svelte';
    import { SignupContext } from '@shared/types';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';
    import { IconName, SvgIcon } from '@uikit/svg-icon';
    import { Size } from '@uikit/types';

    import s from './info.module.css';

    export let story: StoryFeedItem;
    export let isDesktop: boolean;
    export let userId: string | null = null;
    export let callHandler: (story: StoryFeedItem) => void;

    let isFavoriteLoading = false;

    async function favoriteHandler() {
        isFavoriteLoading = true;
        await addUserToFavorite({
            partner: {
                id: story.operatorId,
                intId: story.operatorIntId,
                displayName: story.operatorDisplayName,
                inFavoriteList: false,
                isOnline: story.isOnline,
            },
            isDesktop,
            isOperator: false,
            place: 'stories',
            ownId: userId as string,
            roomId: undefined,
            storyId: story.id,
        });
        await storyFeedStore.loadStories(true);
        isFavoriteLoading = false;
    }

    function unauthorizedHandler() {
        dialogStore.showSignup({
            place: SignupContext.AddToFavorites,
            placeDetails: { storyId: story.id },
        });
    }
</script>

<div class={s.root}>
    {#if story}
        <div class={s.operatorInfoWrap}>
            <div class={s.operatorInfo}>
                <Font
                    className={s.displayName}
                    type={FontTypes.Type.h4}
                    tagName={FontTypes.TagName.h3}
                    isBold
                >
                    {story.operatorDisplayName}
                </Font>
                <Font
                    className={cn(s.status, { [s.online]: story.isOnline })}
                    type={FontTypes.Type.body}
                    tagName={FontTypes.TagName.div}
                    color={FontTypes.Color.Secondary}
                >
                    {story.isOnline ? $LL.favorites.online() : $LL.favorites.offline()}
                </Font>
            </div>

            {#if userId && story.inFavoriteList && story.isOnline}
                <Button
                    classes={s.action}
                    color={ButtonTypes.Color.Brand}
                    size={Size.Big}
                    on:click={() => callHandler(story)}
                >
                    <SvgIcon classes={s.storiesIcon} icon={IconName.Call} />
                    {$LL.story.buttonCall()}
                </Button>
            {/if}

            {#if userId && !story.inFavoriteList}
                <Button
                    classes={s.action}
                    color={ButtonTypes.Color.Brand}
                    size={Size.Big}
                    disabled={isFavoriteLoading}
                    on:click={favoriteHandler}
                >
                {#if isFavoriteLoading }
                    <Spinner size={SpinnerSize.Small} />
                {:else}
                    <SvgIcon classes={s.storiesIcon} icon={IconName.Star} />
                {/if}
                    {$LL.story.buttonFavorite()}
                </Button>
            {/if}

            {#if !userId}
                <Button
                    classes={s.action}
                    color={ButtonTypes.Color.Brand}
                    size={Size.Big}
                    on:click={unauthorizedHandler}
                >
                    <SvgIcon classes={s.storiesIcon} icon={IconName.Call} />
                    {$LL.story.buttonUnauthorized()}
                </Button>
            {/if}

        </div>
    {/if}
</div>
